import { ThemeOptions } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';
import { cssVars } from '../../utils/cssVars';

const snackbarVars = cssVars(
  {
    accentColor: undefined,
    iconColor: undefined,
  },
  'ds-snackbar'
);

export const snackbarTheme: ThemeOptions['components'] = {
  DsSnackbar: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        minHeight: '56px',
        background: tokens.theme.bg.structural.surfaceInverse,
        color: tokens.theme.fg.structural.primaryOnInverse,
        borderRadius: tokens.theme.radius.sm,
        paddingLeft: '12px',

        ...theme.typography.P14R,

        ...(ownerState?.icon ? { paddingLeft: '0', border: 'none' } : {}),

        '& .DsSnackbar-close, & .DsSnackbar-action': {
          marginLeft: 'auto',
          marginRight: '12px',
        },
        '& .DsSnackbar-close': {
          opacity: 0.4,

          '&:hover': {
            opacity: 1,
          },
        },
      }),
      icon: {
        display: 'flex',
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        borderRadius: '4px 0 0 4px',
        background: snackbarVars.refs.accentColor,
        color: snackbarVars.refs.iconColor,
      },
      info: snackbarVars.setValues({
        accentColor: tokens.theme.bg.status.infoStrong,
        iconColor: tokens.theme.fg.status.onInfoStrongInverse,
      }),
      success: snackbarVars.setValues({
        accentColor: tokens.theme.bg.status.successStrong,
        iconColor: tokens.theme.fg.status.onSuccessStrongInverse,
      }),
      warning: snackbarVars.setValues({
        accentColor: tokens.theme.bg.status.warningStrong,
        iconColor: tokens.theme.fg.status.onWarningStrongInverse,
      }),
      error: snackbarVars.setValues({
        accentColor: tokens.theme.bg.status.errorStrong,
        iconColor: tokens.theme.fg.status.onErrorStrongInverse,
      }),
    },
  },
};
